import { AbstractPageDataProvider } from "@/lib/utility/data/page-data-provider.abstract";
import { IPageViewModel } from "@/lib/utility/data/page-view-model.interface";
import { ITicket } from "@/models/ticket.entity";
import ticketService from "@/services/mrfiktiv/services/ticketService";
import { MrfiktivTicketControllerGetParamsGen } from "@/services/mrfiktiv/v1/data-contracts";
import Vue from "vue";
import { FleetAggregationModule } from "../fleet-aggregation.store";

export const TicketPageDataProvider = new (class extends AbstractPageDataProvider<
  ITicket,
  MrfiktivTicketControllerGetParamsGen
> {
  async getPage(query: MrfiktivTicketControllerGetParamsGen): Promise<IPageViewModel<ITicket>> {
    const res = await ticketService.getAll({ ...query });

    const meta = res.meta;
    const data = (res.data || []) as ITicket[];

    Vue.$log.debug("Paged tickets. Parsing for fleet ", data?.length);
    FleetAggregationModule.parseTickets(data);

    return { meta, data };
  }
})();
